import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Row } from 'reactstrap';
import { toast } from "react-toastify";
import { QrReader } from '.';
import { DesktopContainer } from '../layouts';
import { storage } from '../utils';

export default function QrCodeLookup() {
   const [data, setData] = useState("");
   const [openQr, setOpenQr] = useState(false);
   const sleep = ms => new Promise(r => setTimeout(r, ms));
   let savedDevice = JSON.parse(storage.getItem("deviceType"));
   const isMobile = savedDevice.isMobile;
   const hasScanner = savedDevice.hasScanner;

   useEffect(() => {
      if (hasScanner)
         inputFocus("searchInput");
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [hasScanner])

   const handleFocus = (event) => event.target.select();

   function handleQrScan(val) {
      setOpenQr(false);  // Hide QR Scanner
      setData(val);
   }

   function handleQrScanFailure(val) {
      setOpenQr(false);  // Hide QR Scanner
      setData("");
      toast.warning("This device does not have a camera.");
   }

   async function inputFocus(fieldname) {
      await sleep(50);  // allows time for input to be recognized
      const el = document.querySelector(`input[name=${fieldname}]`);
      if (el !== null) {
         await el.focus();
      }
   }

   async function setCode(code) {
      if (hasScanner && code)
         setData(code);
      else
         setData("");

      inputFocus("searchInput");
   }

   return (
      <DesktopContainer screenName="Read QR Code">
         <div className="filter-header">
            <br />
            {isMobile && hasScanner ?
               <div>
                  <Row className="justify-content-center">
                     <Col xs={11}>
                        <Input
                           name="searchInput"
                           placeholder="Handheld Focus"
                           className="h-100"
                           onFocus={handleFocus}
                           onChange={(e) => setCode(e.target.value)}
                        />
                     </Col>
                  </Row>
                  <Row className="justify-content-center">
                     <Col xs={11}>
                        <Button className="shredButton btn-md" onClick={() => setCode("")}>
                           Clear Input
                        </Button>
                     </Col>
                  </Row>
               </div>
               : null
            }
            <Row className="justify-content-center">
               <Col xs={11}>
                  <Button className="shredButton btn-md" onClick={() => setOpenQr(!openQr)}>
                     {openQr ? "Hide Scanner" : "Scan QR Code"}
                  </Button>
               </Col>
            </Row>
            <Row className="justify-content-center">
               <Col xs={11}>
                  <span className="">
                     {data || ""}
                  </span>
               </Col>
            </Row>
            {openQr && <QrReader callback={handleQrScan} callbackError={handleQrScanFailure} />}
         </div>
      </DesktopContainer >
   );
}
